//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'postMetaInfo',
  created() {
    // do something
  },
  props: ['post'],
  data() {
    return {
    }
  },
  methods: {
  }
}



// WEBPACK FOOTER //
// ./src/components/post/PostMetaInfo.vue